import { ValidatorFn, AbstractControl } from "@angular/forms";

const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,})$/;

export const validatorPasswordFNC = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const isValid = passwordRegex.test(control.value);
        return !isValid ? { 'DOESNOT_MATCHED_PASSWORD_REGEX': control.value } : null;
    };
}